import { FLEET_SLASH_COMMANDS_DATA } from "./fleet-slash-commands.data.ts";

export type FleetSlashCommand = {
  name: string;
  description: string;
  acceptsArgs: boolean;
};

// JAISIU-3588 (followup) — pick the LAST unterminated
// /token in the draft (not just at the start) so the `+`
// popover's Commands entry can append `/` mid-message and
// have the picker open against the new token. The gateway
// only routes slash commands at message start, but the picker
// itself is just a discovery UI for the operator.
const SLASH_COMMAND_RE = /(?:^|\s)\/([A-Za-z0-9._-]*)$/;

export type SlashCommandState = { open: boolean; query: string };

export function listFleetSlashCommands(): FleetSlashCommand[] {
  return FLEET_SLASH_COMMANDS_DATA;
}

/**
 * Opens when the draft is only a leading slash command token (no trailing text yet),
 * matching how chat.send routes slash commands on the gateway.
 */
export function extractSlashCommandQuery(draft: string): SlashCommandState {
  const match = SLASH_COMMAND_RE.exec(draft);
  if (!match) {
    return { open: false, query: "" };
  }
  return { open: true, query: match[1] ?? "" };
}

export function filterSlashCommands(
  commands: FleetSlashCommand[],
  query: string,
): FleetSlashCommand[] {
  const q = query.trim().toLowerCase();
  if (!q) {
    return commands;
  }
  return commands.filter(
    (cmd) => cmd.name.includes(q) || cmd.description.toLowerCase().includes(q),
  );
}

export function formatSlashCommandDraft(command: FleetSlashCommand): string {
  return command.acceptsArgs ? `/${command.name} ` : `/${command.name}`;
}
